import Error from '@components/error';
import { PureComponent, type ReactNode } from 'react';

export default class ErrorBoundary extends PureComponent<{ children: ReactNode }, { error: unknown }> {
  state = { error: undefined };

  static getDerivedStateFromError(error: unknown) {
    return { error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.error(error, errorInfo.componentStack);
  }

  render() {
    if (this.state.error) {
      return <Error error={this.state.error} />;
    }

    return this.props.children;
  }
}
